"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const StatusIndicator_1 = require("../../styled/StatusIndicator");
exports.TableFilter = ({ onFilterChange, filters, value, }) => {
    const onChange = (value) => {
        const option = filters.find((v) => v.label === value);
        option && onFilterChange && onFilterChange(option);
    };
    const filterLabels = filters.map(({ label }) => ({ label, value: label }));
    const filterValue = value || filterLabels[0];
    return (react_1.default.createElement(StatusIndicator_1.StyledCustomDropDown, { icon: filterValue.label === "all" || "All"
            ? "fa master-tc-filter fa-trash test-filter-button"
            : "fa navIcon-filter-applied fa-trash test-filter-selected", onChange: onChange, className: "mx-2", disabled: !Boolean(filterLabels.length), value: filterValue === null || filterValue === void 0 ? void 0 : filterValue.label, options: filterLabels, name: "table-filters", right: true }));
};
//# sourceMappingURL=TableFilter.js.map